import ResizeDetector from 'shared/components/ResizeDetector'
import { createReactRouterRoutes } from 'routing/createReactRouterRoutes'
import { HelmetProvider } from 'react-helmet-async'
import { createBrowserRouter } from 'react-router-dom'
import { useLocation } from 'react-router'
import {
  createStaticRouter,
  createStaticHandler
} from 'react-router-dom/server'
import ApplicationContainer from 'infrastructure/Application/Container'
import { APIProvider as GoogleMapsProvider } from '@vis.gl/react-google-maps'
import locales from 'locales'
import { TranslationContainer } from 'react-i18n-lite'
import { createTanstackRouter } from './createTanstackRouter'
import { AnyRouter } from '@tanstack/react-router'

const LayoutComponent = () => {
  const { pathname } = useLocation()

  return (
    <TranslationContainer locales={locales} defaultLanguage='pt-BR'>
      <HelmetProvider>
        <GoogleMapsProvider apiKey={globalThis.googleCloudApikey}>
          <ResizeDetector>
            <ApplicationContainer key={pathname} />
          </ResizeDetector>
        </GoogleMapsProvider>
      </HelmetProvider>
    </TranslationContainer>
  )
}

type CreateServerReactRouterProps = {
  tanstackRouter: AnyRouter
  request: Request
}

export const createServerReactRouter = async ({
  request,
  tanstackRouter
}: CreateServerReactRouterProps) => {
  const routes = createReactRouterRoutes({ tanstackRouter })

  const { dataRoutes, query } = createStaticHandler([
    {
      element: <LayoutComponent />,
      children: routes
    }
  ])

  const context = await query(request)

  // If we got a redirect response, short circuit and let our Express server
  // handle that directly
  if (context instanceof Response) {
    throw context
  }

  return { router: createStaticRouter(dataRoutes, context), context }
}

export const createClientReactRouter = () => {
  const routes = createReactRouterRoutes({
    tanstackRouter: createTanstackRouter()
  })

  return createBrowserRouter([
    {
      element: <LayoutComponent />,
      children: routes
    }
  ])
}
